// removed by extract-text-webpack-plugin
module.exports = {"close":"Dismissable--close--db"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Dismissable/styles.styl
// module id = 815
// module chunks = 0